import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-clip-icon',
  templateUrl: './general-clip.component.html'
})
export class GeneralClipComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
